import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function DoubleChatBubbleIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2272 10.5C18.8553 11.2712 19.2329 12.3078 19.2329 13.63C19.2329 14.8662 18.9029 15.8526 18.3467 16.606C18.145 16.8793 18.1875 17.5163 18.3487 17.8153C18.7345 18.5309 18.0055 19.315 17.2131 19.1333C16.62 18.9974 15.9979 18.8134 15.4534 18.5666C15.2541 18.4762 15.034 18.4398 14.8165 18.4644C14.5463 18.4949 14.2706 18.5101 13.9914 18.5101C12.6956 18.5101 11.4748 18.1846 10.5378 17.5M15.233 9.63003C15.233 12.9956 12.7865 14.5101 9.99151 14.5101C9.7123 14.5101 9.43657 14.4949 9.16641 14.4644C8.94893 14.4398 8.72883 14.4762 8.5295 14.5666C7.98504 14.8134 7.3629 14.9974 6.76977 15.1333C5.97738 15.315 5.24836 14.5309 5.63421 13.8153C5.79543 13.5163 5.83794 12.8793 5.6362 12.606C5.08005 11.8526 4.75 10.8662 4.75 9.63003C4.75 6.26449 7.19653 4.75 9.99151 4.75C12.7865 4.75 15.233 6.26449 15.233 9.63003Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
